<template>
  <div class="first-step-component">
    <!--    <food-window
      v-if="showFoodWindow"
      :item="currentFoodItem"
    />

    <section v-show="!showFoodWindow && !showPromotionsWindow">
      <food-categories />
      <v-row v-if="menuItems.length" class="menu-items">
        <v-loader v-show="isLoading" absolute />
        <v-col v-for="item in computedMenuItems" :key="item.id" sm="4" xl="3">
          <food-card
            :item="item"
            @openFoodWindow="openFoodWindow"
            new
            bonus
            child
          />
        </v-col>
      </v-row>
      <span v-else class="d-block display-3 text-center">Ничего не найдено</span>
    </section>-->
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import FoodCategories from './food-categories/FoodCategories'
  import FoodCard from '../../order-components/first-step/FoodCard.vue'
  import FoodWindow from '@/components/order-processing/order-components/first-step/FoodWindow'

  export default {
    name: 'FirstStep',
    components: {
      VLoader,
      FoodCategories,
      FoodCard,
      FoodWindow,
    },
    data () {
      return {
        currentFoodItem: {},
      }
    },
    computed: {
      ...mapState({
        showFoodWindow: state => state.newOrder.showFoodWindow,
        showPromotionsWindow: (state) => state.newOrder.showPromotionsWindow,
        isLoading: (state) => state.newOrder.isMenuItemsLoading,
        menuItems: (state) => state.newOrder.menuItemsList || [],
        searchMenu: state => state.newOrder.searchMenu,
        allMenuItemsList: state => state.newOrder.allMenuItemsList,
      }),
      ...mapGetters({
        allMenuItems: 'newOrder/getAllMenuItems',
      }),
      computedMenuItems () {
        if (this.searchMenu) {
          return this.allMenuItems.filter(item => {
            const itemName = item.name.toLowerCase()
            const searchString = this.searchMenu.toLowerCase()
            return itemName.includes(searchString)
          })
        }
        return this.menuItems
      },
    },
    methods: {
      openFoodWindow (item) {
        this.currentFoodItem = item
      },
    },
    beforeDestroy () {
      this.$store.commit('newOrder/setFoodWindowState', false)
    },
  }
</script>

<style lang="less" scoped>
.first-step-component {
  background-color: transparent;

  .menu-items {
    position: relative;
    z-index: 0;
  }

}
</style>
